/**
 * B863 — a WORDMARK logo already spells the club's name. Measured at 390 on
 * dev: Stand Up Live's 900×186 and Harbor Lights' 300×69 took the brand's
 * slot and left the name 13 px ("S."). A logo at least 2.5 times as wide as
 * it is tall carries the name; a square or near-square mark does not, and
 * an image with no size yet (not loaded) carries nothing.
 */
export const WORDMARK_RATIO = 2.5;

export function logoCarriesName(naturalWidth: number, naturalHeight: number): boolean {
  return naturalWidth > 0 && naturalHeight > 0 && naturalWidth / naturalHeight >= WORDMARK_RATIO;
}
